import PropTypes from 'prop-types';
import React from 'react';
import SecondaryNav from '../../Common/containers/SecondaryNav';

function HorseRacingNav({open, opener, moreOpen, moreOpener}) {
  const props = {
    open,
    opener,
    moreOpen,
    moreOpener,
    title: "Racing",
    links: [
      {href: "/racing", text: "News", isIndex: true},
      {href: "/racing/racecards", text: "Racecards"},
      {href: "/racing/fast-results", text: "Fast Results", alternatives: [{href: "/racing/meeting/"}]},
      {href: "/racing/results", text: "Full Results"},
      {href: "/racing/non-runners", text: "NRs"},
      {href: "/racing/my-stable", text: "My Stable", inDropdown: true, exceptions: [{href: "/racing/my-stable/search"}]},
      {href: "/racing/tips-centre", text: "Tips", inDropdown: true},
      {href: "/racing/my-stable/search", text: "Search", inDropdown: true},
      {href: "/racing/naps-table", text: "Naps", inDropdown: true},
      {href: "/racing/abc-guide", text: "ABC", inDropdown: true},
      {href: "/racing/going", text: "Going"},
      {href: "/racing/columnists/richard-fahey", text: "Richard Fahey", inDropdown: true}
    ]
  };

  return (
    <SecondaryNav {...props}/>
  );
}

HorseRacingNav.propTypes = {
  open: PropTypes.bool.isRequired,
  opener: PropTypes.func.isRequired,
  moreOpen: PropTypes.bool,
  moreOpener: PropTypes.func
}

export default HorseRacingNav



// WEBPACK FOOTER //
// ./modules/HorseRacing/nav/HorseRacingNav.js